function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
export { _nonIterableSpread as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 1076
// module chunks = 0